import * as z from 'zod';

import { addressQuerySchema } from '@/_containers/inputs/address/shared/address-query-schema';
import { fileQuerySchema } from '@/_schemas/file';
import { currencyInput, nullableNumericQuerySchema, paginatedResponseSchema } from '@/_schemas/generic';
import { phoneNumberQuerySchema } from '@/_schemas/phone-numbers';

import { inventoryVendorQueryLinkerSchema } from './inventory-vendor-query-linker-schema';

const inventoryVendorTypeSchema = z.enum(['primary', 'secondary']);
export type InventoryVendorType = z.infer<typeof inventoryVendorTypeSchema>;

export const inventoryVendorQuerySchema = z.object({
  ...inventoryVendorQueryLinkerSchema.shape,
  vendor_id: z.string(),
  sku_label: z.string().nullable(),

  tax_id: z.string().nullable(),
  url: z.url().nullable(),
  notes: z.string().nullable(),
  account_number: z.string().nullable(),

  sku_start_number: nullableNumericQuerySchema(),
  credit_limit: currencyInput.querySchema(),

  phone_numbers: z.array(phoneNumberQuerySchema).nullish(),
  vendor_w9_file: z.array(fileQuerySchema).nullish(),

  addresses: z.array(addressQuerySchema).nullish(),

  pivot: z
    .object({
      type: inventoryVendorTypeSchema,
    })
    .optional(),
});

export type InventoryVendorQuerySchema = z.infer<typeof inventoryVendorQuerySchema>;

export const tcCategoryQueryAllSchema = paginatedResponseSchema(inventoryVendorQuerySchema);

export type InventoryVendorQueryAllSchema = z.infer<typeof tcCategoryQueryAllSchema>;
